import { TableTemplate } from '@/features/baseTable'
import { CardTableSkeleton } from '@/features/baseTable/ui/CardTableSkeleton'
import { FINANCE_STATUS_MAP, getFinanceColumns, useFinances } from '@/features/finance'
import { BaseCard, FilterButton, FilterButtonModel } from '@/shared/components'
import { useState } from 'react'
import { Link } from 'react-router-dom'

const filterButtons: FilterButtonModel[] = [
  { name: 'Все', label: 'all', index: 1 },
  { name: 'Выводы', label: 'withdrawal', index: 2 },
  { name: 'Пополнения', label: 'deposit', index: 3 },
]

export const FinanceTableCard = () => {
  const [selectedStatus, setSelectedStatus] = useState(1)
  const handleFilterClick = (button: FilterButtonModel) => {
    setSelectedStatus(button.index)
  }

  const status = FINANCE_STATUS_MAP[selectedStatus]

  const { data } = useFinances({ status: status ?? 1, take: 10, skip: 0 })

  return (
    <BaseCard className="w-full" variant="secondary" radius="lg">
      <div className="flex justify-between items-center mb-4 md:mb-6">
        <h3>Финансы</h3>
        <Link to="/finance" className="text-primary dark:text-primary-dark text-sm">
          Показать все
        </Link>
      </div>
      <div className="flex gap-0.5 mb-5 p-0.5 overflow-x-auto scrollbar-hide">
        {filterButtons.map((b) => (
          <FilterButton
            key={b.index}
            name={b.name}
            onClick={() => handleFilterClick(b)}
            selected={b.index === selectedStatus}
            padding="sm"
          />
        ))}
      </div>

      {data.error ? (
        <p>Ошибка загрузки данных.</p>
      ) : data.isLoading ? (
        <CardTableSkeleton />
      ) : !data.items || data.items.length === 0 ? (
        <p>Данных нет.</p>
      ) : (
        <TableTemplate columns={getFinanceColumns({ isDashboard: true })} data={data.items} />
      )}
    </BaseCard>
  )
}
